import app from 'flarum/forum/app';
import ResultsModal from '../components/ResultsModal';
export default function checkForApproval() {
  return new Promise(() => {
    setTimeout(() => {
      var _user$lastNicknameReq, _user$lastUsernameReq;
      const user = app.session.user;
      if (!user) return;
      const approvedNickname = user.lastNicknameRequest() && ((_user$lastNicknameReq = user.lastNicknameRequest()) == null ? void 0 : _user$lastNicknameReq.status()) !== 'Sent';
      const approvedUsername = user.lastUsernameRequest() && ((_user$lastUsernameReq = user.lastUsernameRequest()) == null ? void 0 : _user$lastUsernameReq.status()) !== 'Sent';
      if (approvedNickname || approvedUsername) {
        app.modal.show(ResultsModal, {
          nickname: approvedNickname
        });
      }
    }, 1000);
  });
}
flarum.reg.add('fof-username-request', 'forum/extenders/checkForApproval', checkForApproval);